import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Building2, Camera, Utensils, Flower, Music, Check } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const categories = [
  { icon: Building2, label: 'Venues' },
  { icon: Camera, label: 'Photographers' },
  { icon: Utensils, label: 'Caterers' },
  { icon: Flower, label: 'Florists' },
  { icon: Music, label: 'Music & DJs' },
];

export default function Partners() {
  const [form, setForm] = useState({ business: '', category: '', city: '', email: '', website: '' });
  const [submitted, setSubmitted] = useState(false);
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    toast({ title: 'Application received 💝', description: 'We’ll review and get back to you within 3 business days.' });
  };

  return (
    <div className="min-h-screen bg-[#FBF7F2]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="section-eyebrow text-center">Become a partner</p>
          <h1 className="font-serif text-4xl lg:text-6xl text-center mt-3 text-[#2A2A2A] leading-tight">
            Get in front of <span className="italic text-[#7B2C3B]">couples who are actually ready</span>.
          </h1>
          <p className="text-center mt-5 text-[#4A4A4A] max-w-2xl mx-auto">
            Yourweddingfriends partners are hand-picked wedding pros our couples see first when they reach the vendor stage of their plan. No noisy directories, no pay-per-click, no inflated lead fees.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-12">
            {categories.map((c) => {
              const Icon = c.icon;
              return (
                <div key={c.label} className="soft-card rounded-2xl p-5 text-center">
                  <Icon className="w-6 h-6 text-[#7B2C3B] mx-auto mb-2" />
                  <p className="text-sm text-[#2A2A2A]">{c.label}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div>
              <h2 className="font-serif text-3xl text-[#2A2A2A] mb-5">What partners get</h2>
              <ul className="space-y-3 text-[#3A3A3A]">
                {[
                  'A polished profile shown inside couples’ vendor shortlist',
                  'Booking-ready leads — not browsers',
                  'Two-way messaging without leaving the app',
                  'A monthly insights report on your conversion',
                  'No commission on bookings, ever',
                ].map((p, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#7B2C3B] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-3 h-3 text-[#FBF7F2]" />
                    </div>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="soft-card rounded-3xl p-7">
              <h3 className="font-serif text-2xl text-[#2A2A2A] mb-1">Apply to join</h3>
              <p className="text-sm text-[#6A6A6A] mb-5">We accept partners on a rolling basis. We review every application.</p>
              {submitted ? (
                <div className="p-4 rounded-xl bg-[#F6EAE0] text-[#7B2C3B] text-sm">
                  Thank you! We’ve received your application and will be in touch within 3 business days.
                </div>
              ) : (
                <form onSubmit={submit} className="space-y-3">
                  <input required value={form.business} onChange={(e) => setForm({ ...form, business: e.target.value })} placeholder="Business name" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <select required value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B] text-[#3A3A3A]">
                    <option value="">Category</option>
                    <option>Venue</option><option>Photographer</option><option>Caterer</option><option>Florist</option><option>Music / DJ</option><option>Other</option>
                  </select>
                  <input required value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="City, State" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Business email" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <input value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} placeholder="Website (optional)" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <button type="submit" className="w-full btn-primary py-3 rounded-full text-sm font-medium">Submit application</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
